import FullInfoField from 'components/FullInfoField/FullInfoField';
import React from 'react';
import { IRestaurantDish } from 'types';
import style from './PriceItem.module.scss';

interface IPriceItem {
	data: IRestaurantDish;
}

const PriceItem: React.FC<IPriceItem> = ({ data }) => {
	return (
		<div className={style.container}>
			<FullInfoField label="restaurantLabel" value={data.restaurantName} />
			<FullInfoField label="signedPriceLabel" value={data.price} />
		</div>
	);
};

export default PriceItem;
